import { useCallback } from "react";
import axios from "axios";

export const useApiError = () => {
  const handleAPIError = useCallback((response: any) => {
    const status = response?.response?.status ?? response?.status ?? null;

    const isNetworkError =
      axios.isAxiosError(response) &&
      (status === 0 || response.code === "ERR_NETWORK");

    const isHttpError = status !== null && status >= 400;

    const isError = !response || isNetworkError || isHttpError;

    if (isError) {
      return {
        isError: true,
        status,
        message:
          response?.response?.data?.error ||
          "Something went wrong. Please try again.",
      };
    }

    return { isError: false, status: status ?? 200 };
  }, []);

  return { handleAPIError };
};
